module.exports = __webpack_public_path__ + "static/media/man.12f85246.svg";